import React from "react";
import CTAButton from "../../generalComponents/ctaButton";


export default function HeaderComponent() {


    return (
        <div>
            {/* Header Image */}
            <div className="mb-20">
                <img
                    className="object-cover w-full"
                    style={{
                        height: "700px",
                    }}
                    src="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/pabloo%2Fmedia%2Fimage01.png?alt=media&token=eb7459db-0760-4d92-831b-70fc6ba2ff2f"
                    alt="Header Banner"
                />
                <style>
                    {`
                    @media (max-width: 767px) {
                        img[alt="Header Banner"] {
                            height: 400px !important;
                        }
                    }
                    `}
                </style>
            </div>

            <div className="flex items-center justify-center">
                <div className="text-center text-black space-y-16" id="header-text-block">
                    <h1
                        className="text-[80px]"
                        id="header-title"
                        style={{
                            fontWeight: "600",
                            fontSize: "80px",
                            lineHeight: "1.2",
                        }}
                    >
                        <div>
                            <div
                                className="color-linear-to-r text-purple-600"
                                style={{
                                    color: "#a945e3",
                                    backgroundClip: "text",
                                }}
                            >
                                Membership tiers.
                            </div>
                        </div>
                        <div>from Pabloo.</div>
                    </h1>

                    <p
                        className="font-semibold text-3xl px-80"
                        id="header-subtext"
                        style={{
                            lineHeight: "1.2",
                        }}
                    >
                        Earn rewards effortlessly on every purchase, with instant payouts at top retailers. Backed by
                        256-bit encryption and fraud protection, so earnings and data are secure.


                        <div className="flex items-center justify-center mt-8">
                            <div
                                className={`primary-button home pricing-cta text-white`}
                                onClick={() => {
                                }}
                                style={{cursor: "pointer"}}
                            >
                                <div className="flex justify-center items-center space-x-4 mr-2">
                                    <div className="mr-2">Go Premium</div>
                                    <div className="button-arrow-embed no-show-class">
                                        <svg
                                            width={10}
                                            height={17}
                                            viewBox="0 0 10 17"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M2 2L8.75 8.75L2 15.5"
                                                stroke="currentColor"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p>
                </div>

                {/* Responsive Styles */}
                <style>
                    {`
                    @media (max-width: 767px) {
                        #header-title {
                            font-size: 32px !important;
                            line-height: 1.2 !important;
                        }

                        #header-subtext {
                            font-size: 16px !important;
                            padding-left: 2.5rem !important;
                            padding-right: 2.5rem !important;
                        }

                        #header-text-block > * + * {
                            margin-top: 1.5rem !important;
                        }
                    }
                    `}
                </style>
            </div>
        </div>
    );
}
